export default {
  title: "[[CR]]",
  number: "No.",
  general: {
    lastPrintedAt: "Last printed at",
  },
  form: {
    general: {
      date: "Date",
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      add_hint: "Ctrl + Enter to add",
      comment_title: "Comments",
      comment: "Comment",
      add_comment: "Add",
      remove_comment: "Remove",
      occurrence_title: "Special Occurrences",
      occurrence: "Special Occurrence",
      add_occurrence: "Add",
      remove_occurrence: "Remove",
    },
    shift: {
      title: "Add new Shift",
      add_shift: "Add",
      edit_shift: "Edit",
      crew: "Crew & equipment",
      list_title: "Shifts",
      new_shift: "New shift",
      when: "Time",
      fromTime: "From Time",
      toTime: "To Time",
      resources: {
        people: "People",
        machines: "Machines",
        materials: "Materials",
      },
      weather: {
        title: "Weather",
        loading: "Fetching weather…",
        adjust: "Adjust",
        done: "Done",
        manual_hint: "Weather couldn't be loaded automatically. Please enter it manually.",
        start: "Start",
        mid: "Middle",
        end: "End",
        time: "Time",
        temperature: "Temperature",
        weather: "Weather",
        // Above the shift's weather hour by hour, under the three readings.
        course: "Weather course",
      },
      user: {
        input: "Project-user",
        title: "Add User",
        user: "User",
        position: "Position",
        no_positions: "No positions available",
        from_project: "Project",
        assigned: "Assigned",
        // Saving hands the position to the project server-side — without a rate, which is a
        // commercial decision. The project's tab reports the missing rate.
        not_in_project: "New to project.",
        headers: {
          name: "Name",
          position: "Position",
        },
      },
      machine: {
        input: "Project-Machine",
        title: "Add Machine",
        machine: "Machine",
        identifier: "Machine-Number",
        no_identifiers: "No machine numbers available",
        follows_shift: "Used for the whole shift",
        follows_shift_hint: "The shift's work time ({hours} h) counts as time of use",
        follows_shift_hint_unset: "The shift's work time counts as time of use",
        hours: "Hours of use",
        hours_max: "At most the shift's work time ({hours} h)",
        hours_positive: "More than 0 hours",
        edit_hours: "Change time of use",
        deviating_hours: "{hours} h",
        duplicate_device: "Already on this shift: device number {devices}.",
        headers: {
          name: "Name",
          identifier: "Machine-Number",
        },
      },
      material: {
        input: "Project-Material",
        title: "Add Material",
        material: "Material",
        amount: "Amount",
        headers: {
          name: "Name",
          amount: "Amount",
        },
      },
      break: {
        title: "Breaks",
        add: "Add break",
        fromTime: "From Time",
        toTime: "To Time",
        remove_break: "Remove",
        add_break: "Add",
        from: "From",
        until: "unitl",
        error: "Break times must be between the 'from' and 'to' times.",
        durationError: "The total break time must not exceed the shift duration.",
      },
    },
    service: {
      title: "New Service",
      edit_service: "Edit Service",
      add_hint: "Ctrl + Enter to add",
      positionIdentifier: "Pos. No. LV",
      description: "Performance Designation",
      amount: "Amount",
      unit: "Unit",
      add_service: "Add",
      remove_service: "Remove",
      list_title: "Services",
    },
    actions: {
      save: "Save",
      cancel: "Cancel",
    },
  },
  // Services on the construction report: booked positions of the service catalogue.
  serviceEntries: {
    loading: "Loading service catalogue…",
    empty: "This project has no service catalogue.",
    empty_hint:
      "Create titles and positions in the project's service catalogue tab or import the offer's bill of quantities. You can still enter free services below.",
    add: "Book a service",
    search: "Search position (no., short text, title)",
    before: "so far {done} of {planned}",
    list_title: "Performed today",
    position: "Position",
    quantity: "Quantity",
    share: "Cost share",
    note: "Note",
    add_note: "Add note",
    remove: "Remove",
    take_rest: "Take remainder",
    stat_before: "So far",
    details: "Details",
    rest_short: "{rest} left",
    done: "done",
    stat_planned: "Planned",
    position_deleted: "The position was deleted from the service catalogue",
    covered_by_stand: "Part of the progress reading of {date}; does not change the actual quantity.",
    excess: "This exceeds the planned quantity by {amount} (overrun).",
    quantity_required: "Enter a quantity",
    quantity_invalid: "Enter a quantity above 0",
    rest_column: "Left",
    flat_rate_share: "{share} % of the lump sum",
    quantity_too_large: "This quantity is too large",
    quantity_unreadable: "Enter a valid number or calculation",
    quantity_info: "Calculations work too, e.g. 12.5+7.5+3 or 3.5x2.4",
    share_required: "Enter a cost share",
    share_range: "Enter a cost share between 0 and 100 %",
    // Free services: free text without a position, never priced (constructionServices).
    free: {
      title: "Free services",
      info: "Not linked to the service catalogue: these entries are printed with the [[cr]] but don't count towards progress, billing or the cost split.",
      compose: "Describe the service",
      add: "Add",
      hint: "Enter to add · Shift + Enter for a new line",
    },
    split: {
      title: "Cost split",
      AUTO: "Automatic",
      MANUAL: "Manual",
      auto_hint: "By earned value (quantity × unit price); equally without prices.",
      manual_hint:
        "How this report's costs (crew, machines, material) are split across the positions. Independent of the quantity: how much was done goes into the quantity field.",
      sum: "Total {sum} %",
      equal: "Split equally",
    },
    quick_create: {
      button: "Position missing?",
      title: "Create change order position",
      hint: "For work not in the offer: the position is assigned to a change order and can be booked right away.",
      change_order: "Change order",
      change_order_hint: "Pick an existing one or leave empty for a new, requested change order.",
    },
  },
  tabs: {
    general: "General",
    shift: "Shifts",
    services: "Services",
    files: "Files",
    activity: "Activity",
  },
  validation: {
    atLeastOneShift: "Need at least one <strong>Shift</strong>",
    atLeastOneCommentOrOccurrenceOrService: "Need at least one comment, service or special occurrence",
    serviceEntries: "A <strong>service</strong> is missing its quantity, or the cost shares do not add up to 100 %",
    atLeastOneUserOrMachine: "Need at least one User or Machine",
    machineHoursExceedShift: "A machine's hours of use exceed the shift's work time",
  },
}
